// GlobalContext.js
import React, { createContext, useState, useEffect } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children, initialData }) => {
  const [globalData, setGlobalData] = useState(initialData);

  useEffect(() => {
    setGlobalData(initialData);
  }, [initialData]);

  return (
    <GlobalContext.Provider value={{ globalData, setGlobalData }}>
      {children}
    </GlobalContext.Provider>
  );
};
